export const CSS = {
  container: "container",
  dividerContainer: "divider-container",
  divider: "divider",
  widthAuto: "width-auto",
  widthHalf: "width-half",
  widthFull: "width-full",
};
